import { MarketplaceOrderItemLabelTextHelper } from '../labelTextHelper/MarketplaceOrderItemLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

const excludedImportFieldList = ['dateCreateAt', 'dateModifyAt'];

export const MarketplaceOrderItemHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            { text: MarketplaceOrderItemLabelTextHelper.getLabelText.orderNumber, value: 'orderNumber' },
            { text: MarketplaceOrderItemLabelTextHelper.getLabelText.marketplaceCode, value: 'marketplaceCode' },
            { text: MarketplaceOrderItemLabelTextHelper.getLabelText.sku, value: 'sku' },
            { text: MarketplaceOrderItemLabelTextHelper.getLabelText.quantity, value: 'quantity' },
            {
                text: MarketplaceOrderItemLabelTextHelper.getLabelText.itemUnitPriceAmount,
                value: 'itemUnitPriceAmount'
            },
            {
                text: MarketplaceOrderItemLabelTextHelper.getLabelText.itemUnitPriceCurrencyCode,
                value: 'itemUnitPriceCurrencyCode'
            },
            {
                text: MarketplaceOrderItemLabelTextHelper.getLabelText.dateCreateAt,
                value: 'dateCreateAt',
                format: 'datetime'
            },
            {
                text: MarketplaceOrderItemLabelTextHelper.getLabelText.dateModifyAt,
                value: 'dateModifyAt',
                format: 'datetime'
            }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: MarketplaceOrderItemLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportWithItemFields() {
        const fields = this.getFilteredHeaderItems().filter(
            (item) => item.value === 'sku' || item.value === 'quantity' || item.value === 'itemUnitPriceAmount'
        );
        return fields.reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportWithItemHeaders() {
        return this.getHeaderItems().filter(
            (item) => item.value === 'sku' || item.value === 'quantity' || item.value === 'itemUnitPriceAmount'
        );
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
